export const blockIconsUiactionsSearchNew = (
	<span className='material-symbols-outlined'>search</span>
);
